<template>
  <div>
    <!-- Top navbar -->
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <!-- Brand -->
        <router-link :to="{name: 'completedSession'}" class="h4 mb-0 text-uppercase d-none d-lg-inline-block">
          Closed Session Details
        </router-link>
        <user-data></user-data>
        
      </div>
    </nav>
    <!-- Page content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="row mb-5 mb-xl-0">
        <div class="col-md-3">
            <h5 class="mt-0">Site</h5>
            <p>le Merit </p>
        </div>
        <div class="col-md-3">
            <h5 class="mt-0">Meter Type</h5>
            <p>GAS</p>
        </div>
        <div class="col-md-3">
            <h5 class="mt-0">surveyed by</h5>
            <p>Akash</p>
        </div>
        <div class="col-md-3">
            <h5 class="mt-0">surveyed Date</h5>
            <p>10/10/2018 to 18/10/2018</p>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Reading</h3>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table class="mt-3" striped hover :items="items" :fields="fields">
                <template slot="lotNo" slot-scope="data">
                  {{data.value}}
                </template>
                <template slot="owner" slot-scope="data">
                  {{data.value}}
                </template>
                <template slot="previousReading" slot-scope="data">
                  {{data.value}}
                </template>
                <template slot="currentReading" slot-scope="data">
                  {{data.value}}
                </template>
                <template slot="billValue" slot-scope="data">
                  {{data.value}}
                </template>
                <template slot="actions" slot-scope="data">
                  Mail | PDF {{data.id}}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
  import userData from '@/pages/Common/userData';

  export default {
    components: {
      userData,
      datePicker
    },
    data () {
      return {
        options: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
        },
        form : {
          session: null,
          meterType: null,
          fromDate: new Date(),
          toDate: new Date(),
        },
        meterTypes: [
            { text: 'Select One', value: null },
            { text: 'Gas', value: 1 },
            { text: 'Electricity', value: 2 },
            { text: 'Water', value: 3 },
        ],
        sessions: [
          { text: 'Select One', value: null },
          'Le Merit (GAS)', 'Le Merit (Electricity)', 'Le Merit (Water)',
        ],
        fields: [
          {
            key: 'lotNo',
            label: 'Lot No',
            sortable: true,
            'class': 'text-center'
          }, {
            key: 'owner',
            label: 'Owner Name',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'previousReading',
            label: 'Previous',
            sortable: false,
            'class': 'text-center'
          },
          {
            key: 'currentReading',
            label: 'Current',
            sortable: false,
            'class': 'text-center'
          },
          {
            key: 'totalConsumption',
            label: 'Total Consumption',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'loadCharge',
            label: 'Load Charge',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'billValue',
            label: 'Bill Value',
            sortable: false,
            'class': 'text-center'
          },
          {
            key: 'actions',
            label: 'Actions',
            sortable: false,
            'class': 'text-center'
          },
        ],
        items: [
          {lotNo:1, owner: 'Owner Name', loadCharge: 213, totalConsumption: 300, previousReading: 180, currentReading: 210, billValue: 250},
          {lotNo:2, owner: 'Owner Name', loadCharge: 243, totalConsumption: 280, previousReading: 160, currentReading: 220, billValue: 280},
          {lotNo:3, owner: 'Owner Name', loadCharge: 218, totalConsumption: 298, previousReading: 155, currentReading: 222, billValue: 230},
        ]
      }
    },
    method() {

    },
    created () {
      if (!localStorage.token) {
        localStorage.clear()
        next({
          name: 'adminLogin'
        })
      } else {
        if(localStorage.roleId == 1){
          this.$router.replace({name: "dashboard"});
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Admin/completedSessionView.vue